import React from 'react'
import Btobtn from './Btobtn'
import ScrollToTop from "./ScrollToTop";
import Nav from "./Nav";

const Defaults = () => {
    return (
        <>
            <Btobtn /><Nav /><ScrollToTop />
        </>
    )
}

export default Defaults
